import { useContext } from 'react';
import { IDCRASChartsDataContext } from '../contexts/IDCRASChartsDataContext';

export const useIDCRASChartsDataContext = () => {
    return useContext(IDCRASChartsDataContext);
};